(function () {
    'use strict';
    // Declare app level module which depends on filters, and services
    var app = angular.module('app', [
        // Angular modules
        'ngRoute',
        'ngAnimate',
        'ngCookies',
        'ngSanitize',
        // Custom modules
        'app.filters',
        'common',
        'ngTable',
        // 3rd Party Modules
        'mm.foundation',
        'yaru22.jsonHuman',
        'authService',
        'flow',
        'ngCsv',
        'ngDialog',
        'ngClipboard',
        'isteven-multi-select',
        'dndLists',
        'ngScrollbars',
        'angularSpinner',
        'chart.js',
        'mp.autoFocus'
    ]);

    // Handle routing errors and success events
    app.run(['authenticationService', '$route', '$rootScope', '$location', '$window', '$cookies',
        function (authenticationService, $route, $rootScope, $location, $window, $cookies) {
            // load lodash
            $rootScope._ = window._;

            $rootScope.$on('$routeChangeStart', function (event, nextRoute) {
                //redirect only if both isAuthenticated is false and no token is set
                if (angular.isDefined(nextRoute.access) &&
                    nextRoute.access.requiredAuthentication &&
                    !authenticationService.isAuthenticated &&
                    !$cookies.get('token'))
                {

                    $cookies.put('loginReturnURL', $location.path());
                    $location.path('/login/');
                }
            });

        }]);

    app.config(['$httpProvider', function ($httpProvider) {
        $httpProvider.interceptors.push('tokenInterceptor');
    }]);

    /*
    app.config(['ngClipProvider', function(ngClipProvider) {
        ngClipProvider.setPath('/scripts/vendor/zeroclipboard/dist/ZeroClipboard.swf');
    }]);
    */
})();